<div *ngIf="spinner" class="preloader-backdrop">
    <div class="page-preloader"> {{loader()}}</div>
</div>